/* PocketPiece product page – original script for Horizon */
const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

function formatMoney(cents, format) {
  const value = Number(cents) / 100;
  const fmt = format || '\x24{{amount}}';
  const withDelims = (n, dec, thou, sep) => {
    const parts = n.toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return parts.length > 1 ? parts[0] + sep + parts[1] : parts[0];
  };
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
    switch (key) {
      case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
      case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
      case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
      default: return withDelims(value, 2, ',', '.');
    }
  });
}

let eventsModule;
async function getEvents() {
  if (eventsModule !== undefined) return eventsModule;
  try { eventsModule = await import('@shopify/events'); } catch (e) { eventsModule = null; }
  return eventsModule;
}

function initSlider(root) {
  if (root.dataset.ppSlider === 'ready') return;
  root.dataset.ppSlider = 'ready';
  const track = root.querySelector('[data-pp-slider-track]');
  const dotsWrap = root.querySelector('[data-pp-slider-dots]');
  if (!track || !dotsWrap) return;
  const slides = Array.from(track.children);
  if (slides.length < 2) { dotsWrap.remove(); return; }
  const dots = slides.map((s, i) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    b.addEventListener('click', () => track.scrollTo({ left: s.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' }));
    dotsWrap.appendChild(b);
    return b;
  });
  const update = () => {
    const w = slides[1].offsetLeft - slides[0].offsetLeft || 1;
    const i = Math.min(slides.length - 1, Math.round(track.scrollLeft / w));
    dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
  };
  track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
  update();
}

function initMain(root) {
  if (root.dataset.ppReady) return;
  root.dataset.ppReady = '1';
  const data = JSON.parse(root.querySelector('[data-pp-json]').textContent);
  const variants = data.variants;
  const byId = (id) => variants.find((v) => String(v.id) === String(id));
  const money = (c) => formatMoney(c, data.moneyFormat);

  /* ---------- gallery ---------- */
  const gallery = root.querySelector('[data-pp-gallery]');
  const track = gallery && gallery.querySelector('[data-pp-track]');
  const slides = track ? Array.from(track.children) : [];
  const thumbs = gallery ? Array.from(gallery.querySelectorAll('[data-pp-thumb]')) : [];
  const thumbRow = gallery && gallery.querySelector('[data-pp-thumbs]');
  const dots = gallery ? Array.from(gallery.querySelectorAll('[data-pp-dot]')) : [];
  let current = 0;
  const setActive = (i) => {
    current = i;
    thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i));
    dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
    const t = thumbs[i];
    if (t && thumbRow && thumbRow.clientWidth) {
      const left = t.offsetLeft - thumbs[0].offsetLeft;
      if (left < thumbRow.scrollLeft || left + t.offsetWidth > thumbRow.scrollLeft + thumbRow.clientWidth) {
        thumbRow.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
  };
  const goTo = (i, smooth = true) => {
    if (!slides.length) return;
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    setActive(i);
  };
  if (track) {
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / (track.clientWidth || 1));
        if (i !== current) setActive(Math.max(0, Math.min(slides.length - 1, i)));
      });
    }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.ppThumb))));
    dots.forEach((d) => d.addEventListener('click', () => goTo(Number(d.dataset.ppDot))));
    const prev = gallery.querySelector('[data-pp-prev]');
    const next = gallery.querySelector('[data-pp-next]');
    prev && prev.addEventListener('click', () => goTo(current - 1));
    next && next.addEventListener('click', () => goTo(current + 1));
  }
  const showMedia = (mediaId, smooth) => {
    if (!mediaId) return;
    const idx = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
    if (idx > -1) goTo(idx, smooth);
  };

  /* ---------- state ---------- */
  const fieldsets = Array.from(root.querySelectorAll('[data-pp-option]'));
  const idInputs = Array.from(root.querySelectorAll('[data-pp-id]'));
  const qtyInput = root.querySelector('[data-pp-qty-input]');
  const atc = root.querySelector('[data-pp-atc]');
  const errorEl = root.querySelector('[data-pp-error]');
  const bundle = root.querySelector('[data-pp-bundle]');
  const cards = bundle ? Array.from(bundle.querySelectorAll('.pp-bundle-card')) : [];
  const allSelects = bundle ? Array.from(bundle.querySelectorAll('.pp-color-select')) : [];
  const sticky = root.querySelector('[data-pp-sticky]');
  const stickySelect = root.querySelector('[data-pp-sticky-select]');
  const stickyAtc = root.querySelector('[data-pp-sticky-atc]');
  const stickyImg = root.querySelector('[data-pp-sticky-img]');
  let variant = byId(idInputs[0] && idInputs[0].value) || variants[0];

  const selectedCard = () => cards.find((c) => c.classList.contains('is-selected')) || null;

  const updateThumb = (select) => {
    const row = select.closest('.pp-color-row');
    const img = row && row.querySelector('.pp-color-thumb');
    const opt = select.options[select.selectedIndex];
    if (img && opt && opt.dataset.image) img.src = opt.dataset.image;
  };

  const getLines = () => {
    const card = selectedCard();
    if (card) {
      const counts = new Map();
      card.querySelectorAll('.pp-color-select').forEach((s) => {
        counts.set(s.value, (counts.get(s.value) || 0) + 1);
      });
      return Array.from(counts, ([id, quantity]) => ({ id: Number(id), quantity }));
    }
    return [{ id: Number(variant.id), quantity: Number(qtyInput ? qtyInput.value : 1) || 1 }];
  };

  const refreshButtons = () => {
    const ok = getLines().every((l) => { const v = byId(l.id); return v && v.available; });
    [atc, stickyAtc].forEach((btn) => {
      if (!btn) return;
      btn.disabled = !ok;
      const label = btn.querySelector('.pp-atc__label');
      if (btn === atc && label) label.textContent = ok ? (atc.dataset.label || 'Add to cart') : 'Sold out';
    });
    if (qtyInput && cards.length) qtyInput.value = getLines().reduce((a, l) => a + l.quantity, 0);
  };

  const renderPrice = () => {
    root.querySelectorAll('[data-pp-price]').forEach((el) => { el.textContent = money(variant.price); });
    root.querySelectorAll('[data-pp-compare]').forEach((el) => {
      const show = variant.compare > variant.price;
      el.hidden = !show;
      if (show) el.textContent = money(variant.compare);
    });
    const pct = variant.compare > variant.price ? Math.floor(((variant.compare - variant.price) * 100) / variant.compare) : 0;
    const mainBadge = root.querySelector('.pp-info [data-pp-badge]');
    const tpl = (mainBadge && mainBadge.dataset.template) || 'SAVE [percentage]';
    root.querySelectorAll('[data-pp-badge]').forEach((el) => {
      el.hidden = pct === 0;
      const t = el.querySelector('[data-pp-badge-text]');
      if (t) t.textContent = tpl.replace('[percentage]', pct + '%');
    });
  };

  const markAvailability = () => {
    fieldsets.forEach((fs, idx) => {
      fs.querySelectorAll('.pp-pill').forEach((pill) => {
        const val = pill.querySelector('input').value;
        const opts = variant.options.slice();
        opts[idx] = val;
        const match = variants.find((v) => v.options.every((o, i) => o === opts[i]));
        pill.classList.toggle('is-unavailable', !match || !match.available);
      });
    });
  };

  const applyVariant = (v, source, smooth = true) => {
    if (!v) return;
    variant = v;
    idInputs.forEach((i) => { i.value = v.id; i.dispatchEvent(new Event('change', { bubbles: true })); });
    fieldsets.forEach((fs, i) => {
      const input = Array.from(fs.querySelectorAll('input')).find((x) => x.value === v.options[i]);
      if (input) input.checked = true;
      const sel = fs.querySelector('[data-pp-selected]');
      if (sel) sel.textContent = v.options[i];
    });
    if (stickySelect) stickySelect.value = String(v.id);
    if (stickyImg && v.image) { stickyImg.src = v.image; stickyImg.removeAttribute('srcset'); }
    if (source !== 'bundle') {
      allSelects.filter((s) => s.dataset.ppSlot === '1').forEach((s) => { s.value = String(v.id); updateThumb(s); });
    }
    renderPrice();
    markAvailability();
    refreshButtons();
    showMedia(v.mediaId, smooth);
    if (source !== 'init') {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {}
    }
  };

  fieldsets.forEach((fs) => fs.addEventListener('change', () => {
    const opts = fieldsets.map((f) => { const c = f.querySelector('input:checked'); return c ? c.value : null; });
    const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
    if (v) applyVariant(v, 'picker');
  }));
  stickySelect && stickySelect.addEventListener('change', () => applyVariant(byId(stickySelect.value), 'sticky'));

  /* ---------- bundle ---------- */
  const selectCard = (card) => {
    cards.forEach((c) => { c.classList.toggle('is-selected', c === card); c.setAttribute('aria-checked', c === card ? 'true' : 'false'); });
    const first = card.querySelector('.pp-color-select[data-pp-slot="1"]');
    if (first) applyVariant(byId(first.value), 'bundle');
    refreshButtons();
  };
  cards.forEach((card) => {
    card.addEventListener('click', (e) => { if (!e.target.closest('.pp-colors')) selectCard(card); });
    card.addEventListener('keydown', (e) => {
      if (e.target !== card) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectCard(card); }
    });
  });
  allSelects.forEach((s) => {
    updateThumb(s);
    s.addEventListener('change', () => {
      updateThumb(s);
      const card = s.closest('.pp-bundle-card');
      if (card === selectedCard() && s.dataset.ppSlot === '1') applyVariant(byId(s.value), 'bundle');
      else refreshButtons();
    });
  });

  /* ---------- add to cart (Horizon native cart drawer) ---------- */
  const setLoading = (on) => {
    [atc, stickyAtc].forEach((b) => { if (b) { b.classList.toggle('is-loading', on); b.setAttribute('aria-busy', on ? 'true' : 'false'); } });
  };
  const showError = (msg) => {
    if (!errorEl) { window.alert(msg); return; }
    errorEl.textContent = msg;
    errorEl.hidden = false;
    clearTimeout(errorEl._t);
    errorEl._t = setTimeout(() => { errorEl.hidden = true; }, 8000);
  };
  let busy = false;
  const addToCart = async (trigger) => {
    if (busy) return;
    const lines = getLines().filter((l) => l.quantity > 0);
    if (!lines.length) return;
    busy = true;
    setLoading(true);
    if (errorEl) errorEl.hidden = true;
    const Ev = await getEvents();
    const CLU = Ev && Ev.CartLinesUpdateEvent;
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId).filter(Boolean);
    const itemCount = lines.reduce((a, l) => a + l.quantity, 0);
    let deferred = null;
    if (CLU && typeof CLU.createPromise === 'function') {
      deferred = CLU.createPromise();
      trigger.dispatchEvent(new CLU({
        action: 'add',
        context: 'product',
        lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity })),
        promise: deferred.promise,
      }));
    }
    try {
      const res = await fetch(data.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines, sections: sectionIds.join(',') }),
      });
      const body = await res.json();
      const cart = await fetch(data.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const failed = !res.ok || Boolean(body.status);
      if (deferred) {
        const detail = { items: cart.items, source: 'product-form-component', sourceId: 'pp-' + data.sectionId, itemCount, productId: String(data.productId), didError: failed };
        if (!failed) detail.sections = body.sections;
        deferred.resolve({ cart: CLU.createCartFromAjaxResponse ? CLU.createCartFromAjaxResponse(cart) : cart, detail });
      }
      if (failed) showError(body.description || body.message || 'Could not add to cart.');
      else if (!deferred) window.location.href = data.cartUrl;
      else document.dispatchEvent(new CustomEvent('pp:cart-added', { detail: { lines, cart } }));
    } catch (err) {
      if (deferred) deferred.reject(err);
      showError('Something went wrong. Please try again.');
    } finally {
      busy = false;
      setLoading(false);
    }
  };
  const form = atc && atc.closest('form');
  form && form.addEventListener('submit', (e) => { e.preventDefault(); e.stopImmediatePropagation(); addToCart(atc); });
  stickyAtc && stickyAtc.addEventListener('click', () => addToCart(stickyAtc));

  /* ---------- sticky bar ---------- */
  if (sticky && atc && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
    });
    io.observe(atc);
  }

  /* ---------- shipping dates ---------- */
  root.querySelectorAll('[data-pp-date]').forEach((el) => {
    const d = (n) => { const x = new Date(); x.setDate(x.getDate() + Number(n || 0)); return MONTHS[x.getMonth()] + ' ' + String(x.getDate()).padStart(2, '0'); };
    const min = Number(el.dataset.min || 0), max = Number(el.dataset.max || 0);
    el.textContent = min === max ? d(min) : d(min) + ' - ' + d(max);
  });

  root.querySelectorAll('[data-pp-slider]').forEach(initSlider);

  applyVariant(variant, 'init', false);
}

function initAll(scope) {
  (scope || document).querySelectorAll('[data-pp-main]').forEach(initMain);
  (scope || document).querySelectorAll('[data-pp-slider]').forEach(initSlider);
}
initAll();
document.addEventListener('shopify:section:load', (e) => initAll(e.target));
